'use client';
import React from 'react';
import Image from 'next/image';

export default function HarrisBrosPromoAd() {
  const handleClick = () => {
    window.open('https://preview.builtwithrocket.new/harrisbrothers-oyyb?p=c', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="relative z-10 py-6 px-4">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={handleClick}
          className="w-full group relative overflow-hidden rounded-2xl border border-primary/30 bg-gradient-to-r from-black/80 via-gray-900/90 to-black/80 backdrop-blur-sm hover:border-primary/60 transition-all duration-300 hover:shadow-[0_0_40px_rgba(var(--primary-rgb),0.25)] cursor-pointer"
          aria-label="Try Harris Brothers App free for 3 days"
        >
          {/* Animated glow accent */}
          <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-accent/10 to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />

          <div className="relative flex flex-col sm:flex-row items-center gap-4 sm:gap-6 p-5 sm:p-6">
            {/* Logo */}
            <div className="flex-shrink-0">
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full overflow-hidden border-2 border-primary/40 group-hover:border-primary/70 transition-colors duration-300 shadow-lg">
                <Image
                  src="/assets/images/harris_final_low_headphones_1024-1785357217989.png"
                  alt="Harris Brothers logo"
                  width={80}
                  height={80}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Text content */}
            <div className="flex-1 text-center sm:text-left">
              <div className="flex items-center justify-center sm:justify-start gap-2 mb-1">
                <span className="text-xs font-semibold uppercase tracking-widest text-primary/80">Powered by Harris Brothers</span>
                <span className="inline-block px-2 py-0.5 rounded-full bg-primary/20 text-primary text-xs font-bold border border-primary/30">NEW</span>
              </div>
              <h3 className="text-white font-bold text-lg sm:text-xl leading-tight mb-1">
                Run Your DJ Business on Autopilot
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed max-w-lg">
                The autonomous app built for DJs &amp; event planners — manage bookings, dispatch vendors, track payments, and communicate with clients, all in one place.
              </p>
            </div>

            {/* CTA */}
            <div className="flex-shrink-0">
              <div className="inline-flex flex-col items-center gap-1">
                <span className="px-5 py-2.5 rounded-xl bg-primary text-black font-bold text-sm group-hover:bg-primary/90 transition-colors duration-200 shadow-md whitespace-nowrap">
                  Try Free for 3 Days →
                </span>
              </div>
            </div>
          </div>
        </button>
      </div>
    </section>
  );
}
